import {Injectable} from '@angular/core';
import {AbstractControl, FormControl, ValidatorFn} from '@angular/forms';
import {GlobalVariable} from '../global';
import {FieldRequestParameters, RequestParameters} from '../shared/models/request-parameters/parameter.model';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
@Injectable()
export class ProfileValidator {

  constructor(private http: HttpClient) {}

  uniqueUsernmeValidator(control: FormControl): Promise<any> | Observable<any> {
    return this.http.get(GlobalVariable.BASE_API_URL + '/profile/username/' + control.value)
      .map(
        (response: any) => {
          console.log(response);
        }
      );
  }
  uniqueEmailValidator(control: FormControl): Promise<any> | Observable<any> {

    const parameters: RequestParameters = new RequestParameters();
    parameters.fields.push(new FieldRequestParameters('email', control.value));
    return this.http.get(GlobalVariable.BASE_API_URL + '/profile', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: any) => {
          console.log(response);
        }
      );
  }
  uniquePhoneValidator(control: FormControl): Promise<any> | Observable<any> {

    const parameters: RequestParameters = new RequestParameters();
    parameters.fields.push(new FieldRequestParameters('phone', control.value));
    return this.http.get(GlobalVariable.BASE_API_URL + '/profile', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: any) => {
          console.log(response);
        }
      );
  }

  samePasswordValidator(control: FormControl, fisrtPassword: string) {
    if (control.value !== fisrtPassword) {
      return {
        notSamePassword: true
      };
    } else {
      return {
        notSamePassword: false
      };
    }
  }

  timezoneOffsetValidator(control: FormControl) {
    let value = + control.value;
      if(value < -12 || value > 14){
        return {
          timezoneOffsetError: true
        };
      }
  }

  confirmPassword(field: AbstractControl): { passwordMismatch: boolean } {
    const fieldParent = field.parent;
    const fieldValue = field.value;
    if (fieldParent !== null && fieldParent !== undefined) {
      const formValue = fieldParent.value;
      if (formValue.plainPasswordFirst !== fieldValue) {
        return {'passwordMismatch': true};
      } else {
        return;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/profile/profile.validators.ts